import React from 'react';
import { useSelector } from 'react-redux';

const HiddenFormFields = () => {
  const registration_type = useSelector(state => state.registration_type);
  const addons = useSelector(state => state.addons);

  return (
    <>
      {registration_type && registration_type.name && (
        <>
          <input type="hidden" name="registration_type[id]" value={registration_type.id || ''} />
          <input type="hidden" name="registration_type[name]" value={registration_type.name || ''} />
          <input type="hidden" name="registration_type[amount]" value={registration_type.amount || 0} />
          <input type="hidden" name="registration_type[description]" value={registration_type.description || ''} />
        </>
      )}

      {addons && addons.map((addon, index) => (
        <React.Fragment key={addon.id || index}>
          <input type="hidden" name={`addons_attributes[${index}][id]`} value={addon.id || ''} />
          <input type="hidden" name={`addons_attributes[${index}][deleted]`} value={addon.deleted ? 1 : 0} />
          <input type="hidden" name={`addons_attributes[${index}][name]`} value={addon.name || ''} />
          <input type="hidden" name={`addons_attributes[${index}][amount]`} value={addon.amount || ''} />
          <input type="hidden" name={`addons_attributes[${index}][description]`} value={addon.description || ''} />
          <input type="hidden" name={`addons_attributes[${index}][metadatum_id]`} value={addon.metadatum_id || ''} />
          <input type="hidden" name={`addons_attributes[${index}][active]`} value={addon.active ? 1 : 0} />
          <input type="hidden" name={`addons_attributes[${index}][position]`} value={index + 1} />
        </React.Fragment>
      ))}
    </>
  );
};

export default HiddenFormFields;
